"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Header = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Container = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    // Grid spacing 相当の左右マージン打ち消し（必要に応じて調整可）
    marginLeft: -theme.spacing(1),
    marginRight: -theme.spacing(1)
  };
});
const Item = (0, _styles.styled)('div')(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    // Grid item 相当の左右パディング
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: '100%',
    // xs: 12
    [theme.breakpoints.up('md')]: {
      width: '50%' // md: 6
    }
  };
});
const Header = props => {
  const {
    intl,
    itemList
  } = props;
  const labelWidth = 160;
  return /*#__PURE__*/_react.default.createElement(Container, null, itemList.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
      label: intl.formatMessage({
        id: item.labelId
      }),
      value: _stringUtil.default.emptyToHyphen(item.value),
      labelWidth: labelWidth
    }));
  }));
};
exports.Header = Header;
var _default = exports.default = (0, _reactIntl.injectIntl)(Header);